window.addEventListener('load', ()=> {
  document.querySelector('[data-variant-toggle]').addEventListener('click', ()=> {
    document.querySelector('[data-variant-toggle]').parentElement.classList.toggle('active')
  })

  if(window.sessionStorage.getItem("FeatureGift") && window.sessionStorage.getItem("FeatureGift") == "true") {
    document.querySelector('.header__trigger-cart .cart-trigger__button').click()
    window.sessionStorage.setItem("FeatureGift", "false");
  }
  document.querySelector('[data-submit-form]').addEventListener('click', (e)=> {
    if(!document.querySelector("[data-variant-item].selected")) {
      document.querySelector('.gift-amount-errors').classList.add('visible');
      return;
    }
    let productVar = document.querySelector("[data-variant-item].selected")?.dataset.variantItem
    let giftFrom = (document.getElementById('giftcard_from').value != '') ? document.getElementById('giftcard_from').value : ''
    let giftTo = (document.getElementById('giftcard_to').value != '') ? document.getElementById('giftcard_to').value : ''
    let giftEmail = (document.getElementById('giftcard_email').value != '') ? document.getElementById('giftcard_email').value : ''
    let giftMessage = (document.getElementById('giftcard_message').value != '') ? document.getElementById('giftcard_message').value : ''

    const fetchConfig = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: productVar,
            quantity: 1,
            properties: {
            'From': giftFrom,
            'To': giftTo,
            'Email': giftEmail,
            'Message': giftMessage
            }
          },
        ],
      }),
    };
    if(giftFrom != '' && giftTo != '' && giftEmail != '' && giftMessage != '') {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,16})+$/.test(giftEmail)) {
        fetch("/cart/add.js", fetchConfig)
          .then((res) => res.json())
          .then((data) => {
             window.sessionStorage.setItem("FeatureGift", "true");
             location.reload();
            //document.querySelector('.header__trigger-cart .cart-trigger__button').click()
         
        });
      } else {
        document.querySelector('.gift-email-errors').classList.add('visible');
        return false;
      }
    }
    else {
      document.querySelector('.gift-errors').classList.add('visible');
      return false;
    }
  })

  document.querySelectorAll('.gift-fields .field__input').forEach((item) => {
    item.addEventListener('click', ()=> {
      document.querySelector('.gift-errors').classList.remove('visible');
      document.querySelector('.gift-email-errors').classList.remove('visible');
    })
  });

  
  document.querySelectorAll("[data-variant-item]").forEach((item) => {
    item.addEventListener('click', ()=> {
      document.querySelector('.gift-amount-errors').classList.remove('visible');
      document.querySelector('.variant-dropdown__title-inner').innerText = item.dataset.variantLabel
      if(document.querySelector("[data-variant-item].selected")) document.querySelector("[data-variant-item].selected").classList.remove('selected');
      item.classList.add('selected');
      document.querySelector('[data-variant-toggle]').click()
    })
  });
})